import { UnSubscribable } from '@core/un-subscrible';
import { Directive, ElementRef, AfterViewInit, OnChanges, SimpleChanges, Input, Renderer2, Inject } from '@angular/core';
import { OverlayContainer, Overlay } from '@angular/cdk/overlay';
import { EigOverlayContainer } from '@core/services/eig-overlay/eig-overlay-container';


@Directive({
    selector: 'eig-table-empty, [eigTableEmpty], [eigTableEmptyDirective]',
    providers: [
        {
            provide: OverlayContainer, useClass: EigOverlayContainer
        }, Overlay
    ]
})
export class EigTableEmptyDirective extends UnSubscribable implements AfterViewInit, OnChanges {

    @Input()
    showEmptyIf = false;

    @Input()
    emptyText = 'Records Not Found'; // TODO translation

    @Input()
    hideEmptyText = true;

    private cols = 0;
    constructor(
        private renderer: Renderer2,
        private elementRef: ElementRef<HTMLElement>) {
        super();

    }

    ngAfterViewInit(): void {
        this.numberOfCols();
        this.showOrRemove();
        // this.hideOrShowEmptyText();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['showEmptyIf']) {
            this.showOrRemove();
        }

        if (changes['hideEmptyText']) {
            this.hideOrShowEmptyText();
        }

        if (changes['emptyText']) {
            this.changeEmptyText();
        }
    }

    getBody(): HTMLElement {
        return (this.elementRef.nativeElement as HTMLElement).getElementsByTagName('tbody')[0];
    }

    getEmptyTemplate(): HTMLElement {
        return this.getBody().getElementsByClassName('table-empty')[0] as HTMLElement;
    }


    numberOfCols(): void {
        const thead = (this.elementRef.nativeElement as HTMLElement).getElementsByTagName('thead')[0];
        const tr = thead.getElementsByTagName('tr')[0];
        this.cols = tr.getElementsByTagName('th').length;
    }

    // TODO: refactoring
    private showOrRemove(): void {
        if (this.showEmptyIf && this.cols !== 0 && !this.getEmptyTemplate()) {
            const trE = this.renderer.createElement('tr');
            this.renderer.addClass(trE, 'table-empty');
            const td = this.renderer.createElement('td');
            this.renderer.setProperty(td, 'innerText', this.emptyText);
            this.renderer.setAttribute(td, 'colspan', this.cols.toString());
            this.renderer.appendChild(trE, td);
            this.renderer.appendChild(this.getBody(), trE);
        } else {
            const empty = this.getEmptyTemplate();
            if (empty) {
                this.renderer.removeChild(this.getBody(), empty);
            }
        }
    }

    private changeEmptyText(): void {
        const emptyTemplate = this.getEmptyTemplate();
        if (emptyTemplate) {
            emptyTemplate.querySelector('td').innerText = this.emptyText;
        }
    }

    private isBlockedUI(): boolean {
        console.log(this.elementRef.nativeElement.classList);
        return this.elementRef.nativeElement.classList.contains('block-ui-container');
    }

    private hideOrShowEmptyText(): void {
        const trEmpty = this.elementRef.nativeElement.getElementsByClassName('table-empty')[0];
        if (trEmpty) {
            const tdEmpty = trEmpty.getElementsByTagName('td')[0];
            if (this.hideEmptyText) {
                this.renderer.setProperty(tdEmpty, 'innerText', '');
            } else {
                this.renderer.setProperty(tdEmpty, 'innerText', this.emptyText);
            }
        }
    }
}
